import { useState, useEffect, useContext } from "react";
import { countTasksForJourneys } from "apps/journeys/utils/helpers";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import TaskCountTable from "../task-count/task-count-table";
import Card from "components/containers/card";

const FIELDS_TO_INCLUDE = ["total", "email", "calls", "notEmailOrPhone", "completed"]; // "notEmailOrPhone" is labeled "Other"

const JourneyTableTaskCount = () => {
  const { journeys } = useContext(JourneysContext);
  const [totals, setTotals] = useState({});
  const [title, setTitle] = useState("");
  const [data, setData] = useState({});

  useEffect(() => {
    const counts = countTasksForJourneys(journeys, FIELDS_TO_INCLUDE);
    const { completed, ...rest } = counts;
    setData(rest); // don't care about completed here
    setTotals(counts);
  }, [journeys]);

  useEffect(() => {
    const total = totals.total;
    const completed = totals.completed;
    let newTitle = "";
    if (total === 0 && completed === 0) {
      newTitle = "No Tasks Due";
    } else if (total > 0) {
      newTitle = "All Cadence Steps";
    } else {
      newTitle = "You completed all your tasks! 🎉";
    }
    setTitle(newTitle);
  }, [totals.total, totals.completed]);

  return (
    <div className="task-counter-card">
      <Card className={"task-counter-card"}>
        <div className="task-card-padding">
          <span className="task-counter-card--title">{title}</span>
          <TaskCountTable data={data} />
        </div>
      </Card>
    </div>
  );
};

export default JourneyTableTaskCount;
